import type { IconKind } from '@/components/AppIcon';

type Tone = 'ok' | 'warn' | 'alert' | 'plain';

/** Every HR state in plain words, with a tone and an icon. */
export const STATES: Record<string, { label: string; tone: Tone; icon: IconKind }> = {
  // Shared
  DRAFT: { label: 'Draft', tone: 'warn', icon: 'statusDraft' },
  PENDING: { label: 'Waiting for a decision', tone: 'warn', icon: 'statusPending' },
  APPROVED: { label: 'Approved', tone: 'ok', icon: 'statusDone' },
  REJECTED: { label: 'Rejected', tone: 'alert', icon: 'statusRefused' },
  CANCELLED: { label: 'Cancelled', tone: 'alert', icon: 'statusRefused' },
  REVERSED: { label: 'Reversed', tone: 'alert', icon: 'statusReversed' },
  POSTED: { label: 'Posted', tone: 'ok', icon: 'post' },
  PAID: { label: 'Paid', tone: 'ok', icon: 'paid' },
  // Advances and loans
  ACTIVE: { label: 'Being recovered', tone: 'plain', icon: 'advance' },
  CLOSED: { label: 'Repaid', tone: 'ok', icon: 'statusDone' },
  // Pay runs
  SUBMITTED: { label: 'Waiting for approval', tone: 'warn', icon: 'submit' },
  // People
  SUSPENDED: { label: 'Suspended', tone: 'warn', icon: 'suspend' },
  LEFT: { label: 'Left', tone: 'alert', icon: 'leaver' },
  // Payslips
  HELD: { label: 'On hold', tone: 'warn', icon: 'hold' },
  UNPAID: { label: 'Not paid yet', tone: 'plain', icon: 'statusPending' },
};

/** A state in plain words, e.g. "ACTIVE" → "Being recovered". */
export function stateLabel(state: string): string {
  return STATES[state]?.label ?? state.charAt(0) + state.slice(1).toLowerCase();
}
